import { useEffect, useState } from 'react';
import { FaGlobeAmericas, FaPhoneAlt, FaTimes } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { AFFILIATE_DISCLOSURE, COMPANY_EMAIL, SITE_NAME, SITE_TAGLINE } from '../../constants/site';
import { PHONE_DISPLAY, PHONE_TEL } from '../../constants/contact';
import './ExploreHeader.css';

const NAV_ITEMS = [
  { hash: '#home', label: 'Search' },
  { hash: '#hotels', label: 'Hotels' },
  { hash: '#cars', label: 'Cars' },
  { hash: '#packages', label: 'Packages' },
  { hash: '#cruises', label: 'Cruises' },
  { hash: '#enquiry', label: 'Contact' },
];

export default function ExploreHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('explore-menu-open', isMobileMenuOpen);
    return () => document.body.classList.remove('explore-menu-open');
  }, [isMobileMenuOpen]);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <div className={`explore-site-header ${isScrolled ? 'explore-site-header--scrolled' : ''}`}>
        <div className="explore-topbar">
          <div className="container explore-topbar__inner">
            <p className="explore-topbar__disclosure" title={AFFILIATE_DISCLOSURE}>
              {AFFILIATE_DISCLOSURE}
            </p>
            <div className="explore-topbar__contact">
              <a href={`mailto:${COMPANY_EMAIL}`} className="explore-topbar__link explore-topbar__link--email">
                <MdEmail aria-hidden />
                <span className="explore-topbar__link-text">{COMPANY_EMAIL}</span>
              </a>
              <a href={`tel:${PHONE_TEL}`} className="explore-topbar__link explore-topbar__link--phone">
                <FaPhoneAlt aria-hidden />
                <span>{PHONE_DISPLAY}</span>
              </a>
            </div>
          </div>
        </div>

        <header className="explore-header">
          <div className="container explore-header__inner">
            <a href="#home" className="explore-header__logo" onClick={closeMenu}>
              <FaGlobeAmericas className="explore-header__logo-icon" aria-hidden />
              <span className="explore-header__logo-text">
                <strong>{SITE_NAME}</strong>
                <small>{SITE_TAGLINE}</small>
              </span>
            </a>

            <nav className="explore-header__nav explore-header__nav--desktop" aria-label="Explore navigation">
              {NAV_ITEMS.map(({ hash, label }) => (
                <a key={hash} href={hash} className="explore-header__link" onClick={closeMenu}>
                  {label}
                </a>
              ))}
            </nav>

            <div className="explore-header__actions">
              <a
                href={`tel:${PHONE_TEL}`}
                className="explore-header__phone-btn"
                aria-label={`Call ${PHONE_DISPLAY}`}
              >
                <FaPhoneAlt aria-hidden />
                <span className="explore-header__phone-label">{PHONE_DISPLAY}</span>
              </a>

              <button
                type="button"
                className={`explore-header__toggle ${isMobileMenuOpen ? 'is-open' : ''}`}
                onClick={() => setIsMobileMenuOpen((o) => !o)}
                aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={isMobileMenuOpen}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </header>
      </div>

      <div
        className={`explore-mobile-menu ${isMobileMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <button type="button" className="explore-mobile-menu__backdrop" aria-label="Close menu" onClick={closeMenu} />
        <aside className="explore-mobile-menu__panel" role="dialog" aria-modal="true" aria-label="Menu">
          <div className="explore-mobile-menu__head">
            <div>
              <p className="explore-mobile-menu__brand">{SITE_NAME}</p>
              <p className="explore-mobile-menu__tagline">{SITE_TAGLINE}</p>
            </div>
            <button type="button" onClick={closeMenu} aria-label="Close menu">
              <FaTimes />
            </button>
          </div>

          <nav className="explore-mobile-menu__nav" aria-label="Explore navigation">
            {NAV_ITEMS.map(({ hash, label }) => (
              <a key={hash} href={hash} onClick={closeMenu}>
                {label}
              </a>
            ))}
          </nav>

          <div className="explore-mobile-menu__footer">
            <a href={`tel:${PHONE_TEL}`} className="explore-mobile-menu__call" onClick={closeMenu}>
              <FaPhoneAlt aria-hidden />
              <span>
                <small>Call 24/7</small>
                <strong>{PHONE_DISPLAY}</strong>
              </span>
            </a>
            <a href={`mailto:${COMPANY_EMAIL}`} className="explore-mobile-menu__email" onClick={closeMenu}>
              <MdEmail aria-hidden /> {COMPANY_EMAIL}
            </a>
            <p className="explore-mobile-menu__disclosure">{AFFILIATE_DISCLOSURE}</p>
          </div>
        </aside>
      </div>
    </>
  );
}
